import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';

interface IServicePlanDetail {
  // tripLegInternalNoteID: string;
}

enum ServicePlanEventType {}
// ServicePlanActivated = 'ServicePlanActivated',
// ServicePlanUpdated = 'ServicePlanUpdated',

/**
 * Method for handling all Internal Note Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateServicePlan(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IServicePlanDetail,
) {
  // switch (detailType) {}
}

export { ServicePlanEventType, updateServicePlan };
